/**
 * @desc：toast组件
 * */

import React from 'react';
import './toast.scss';
class Toast extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      content: props.content,
      show: false
    };
  }
  render() {
    return <div className={`toast-wrapper ${this.state.show ? 'showToast' : 'hideToast'}`}>{this.state.content}</div>;
  }
  componentDidMount() {
    this.setState({
      show: true
    });
  }
}

export default Toast;
